export default __webpack_public_path__ + "static/media/KJUUPio-Icon.0ce4b7dd.svg";